import React from 'react';
import RsrcDetailRendererFactory from "../../../components/RsrcDetailRendererFactory.js";
class PlainTextRsrcModelEditor extends React.Component {
  render() {
    const {
      rsrc,
      detailModel,
      width
    } = this.props;
    const editorDetail = RsrcDetailRendererFactory.create(detailModel ?? rsrc?.data, {
      rsrc,
      width
    });
    return editorDetail;
  }
}
PlainTextRsrcModelEditor.PLUGIN = {
  type: 'text/plain',
  editor: PlainTextRsrcModelEditor
};
export default PlainTextRsrcModelEditor;